module.exports = __webpack_public_path__ + "static/media/bannerMobile@2x.319e51fc.jpg";